import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  hasNext,
  hasPrev,
  total,
  perPage
}) => {
  const startItem = (currentPage - 1) * perPage + 1;
  const endItem = Math.min(currentPage * perPage, total);

  const handlePrevious = () => {
    if (hasPrev) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (hasNext) {
      onPageChange(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total is small
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show pages around current page
      const start = Math.max(1, currentPage - 2);
      const end = Math.min(totalPages, currentPage + 2);

      if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push('...');
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < totalPages) {
        if (end < totalPages - 1) pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination">
      <button
        className={`btn btn-outline ${!hasPrev ? 'disabled' : ''}`}
        onClick={handlePrevious}
        disabled={!hasPrev}
      >
        <FiChevronLeft size={16} />
        Previous
      </button>

      <div className="pagination-info">
        Showing {startItem.toLocaleString()}-{endItem.toLocaleString()} of {total.toLocaleString()} articles
      </div>

      <div style={{ display: 'flex', gap: '0.25rem' }}>
        {getPageNumbers().map((page, index) => (
          <button
            key={index}
            type="button"
            className={`btn ${page === currentPage ? 'btn-primary' : 'btn-outline'} ${
              page === '...' ? 'disabled' : ''
            }`}
            onClick={() => typeof page === 'number' && onPageChange?.(page)}
            disabled={page === '...' || page === currentPage}
            style={{ minWidth: '2.5rem' }}
          >
            {page}
          </button>
        ))}
      </div>

      <button
        className={`btn btn-outline ${!hasNext ? 'disabled' : ''}`}
        onClick={handleNext}
        disabled={!hasNext}
      >
        Next
        <FiChevronRight size={16} />
      </button>
    </div>
  );
};

export default Pagination;
